import { httpApi } from "@/services/http.api";

export const getStreamingEvents = async () => {
  const response = await httpApi.get("/streaming-events");
  return response.data;
};

export const loadAxisDiskStatus = async () => {
  const response = await httpApi.get(`/axis/disk-status`);
  return response.data || [];
};

export const refreshAxisCamera = async (identifier) => {
  const response = await httpApi.post(
    `/axis/disk-status/${identifier}/refresh`
  );
  return response.data;
};

export const loadRetentionRules = async () => {
  const response = await httpApi.get(`/axis/event-days-to-keep`);
  return response.data || [];
};

export const createRetentionRule = async (rule) => {
  const response = await httpApi.post(`/axis/event-days-to-keep`, rule);
  return response.data;
};

export const deleteRetentionRule = async (
  recorderIdentifier,
  streamingEventId
) => {
  const response = await httpApi.delete(
    `/axis/event-days-to-keep/${encodeURIComponent(
      recorderIdentifier
    )}/${encodeURIComponent(streamingEventId)}`
  );
  return response.data;
};

export const updateRetentionDays = async (
  recorderIdentifier,
  streamingEventId,
  daysToKeep
) => {
  const response = await httpApi.patch(
    `/axis/event-days-to-keep/${encodeURIComponent(
      recorderIdentifier
    )}/${encodeURIComponent(streamingEventId)}/days`,
    { daysToKeep }
  );
  return response.data;
};

export const updateRetentionActive = async (
  recorderIdentifier,
  streamingEventId,
  isActive
) => {
  const response = await httpApi.patch(
    `/axis/event-days-to-keep/${encodeURIComponent(
      recorderIdentifier
    )}/${encodeURIComponent(streamingEventId)}/active`,
    { isActive }
  );
  return response.data;
};
